/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../DateTimeFilterController',
	'underscore'
], function(BaseClass, _) {
	'use strict';

	var DateTimeLocalFilterController = BaseClass.extend({
		init: function(options) {
			DateTimeLocalFilterController.inherited('init', this, arguments);

			this.visualization = options.visualization;
			this.localFilters = this.visualization.getLocalFilters();

			this.id = _.uniqueId('DateTimeLocalFilterController');

			// ignore the aggregation for hierarchical filter
			delete this.itemContext.aggregationType;
		},

		initialize: function(){
			return this._initializeModelAndView();
		},

		_initializeExtraData: function () {
		},

		_getSelection: function(){
			const filter = this._getFilter();
			const filterValues = filter && filter.values;
			var invertedFlag = this._getSelectionIsInverted();
			if (filterValues && filterValues.length) {
				if (filterValues.length === 1) {
					if (filter.operator === 'gt') {
						return {
							from: filterValues[0].u,
							to: '',
							inverted: invertedFlag
						};
					} else {
						return {
							from: '',
							to: filterValues[0].u,
							inverted: invertedFlag
						};
					}
				} else {
					return {
						from: filterValues[0].u,
						to: filterValues[1].u,
						inverted: invertedFlag
					};
				}
			}
		},
		_getDialogCaption: function(){
			return this.itemContext.itemName;
		},

		_getSelectionIsInverted: function(){
			const filter = this._getFilter();
			return filter && filter.operator.indexOf('not') >= 0 ? true : false;
		},

		_getItemDataType: function(){
			return this.itemContext.dataType;
		},

		_getFilter: function() {
			return _.find(this.localFilters.getFilterList(), filter => {
				return filter.columnId === this.itemContext.itemId;
			});
		},

		_updateFilter: function(state){
			let _update = {
				command: 'replace',
				preOrPost: 'pre',
				exclude: state.inverted,
				from: state.from,
				to: state.to
			};

			if(this.metadataInfo && this.metadataInfo.isProperty){
				_update.type = 'display';
			}
			if (this.localFilters.filterExists(this.itemContext)) {
				this.localFilters.editFilter(this.itemContext, _update);
			} else {
				this.localFilters.addFilter(this.itemContext, _update);
			}
		},

		_removeFilter: function() {
			this.localFilters.removeFilter(this.itemContext);
		},

		onDone: function(){
			DateTimeLocalFilterController.inherited('onDone', this, arguments);
			if(this.commonView.remove){
				this.commonView.remove();
			}
		},

		onClose: function(){
			DateTimeLocalFilterController.inherited('onClose', this, arguments);
			if(this.commonView.remove){
				this.commonView.remove();
			}
		}
	});
	return DateTimeLocalFilterController;
});
